import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';

export interface OnboardingStatus {
  currentStep: number;
  completedSteps: string[];
  isComplete: boolean;
}

export interface ProfileStepData {
  practiceName: string;
  specialty: string;
  phone: string;
  website?: string;
  address: string;
  city: string;
  state: string;
  zip: string;
}

export interface StrategyStepData {
  targetPatients: string[];
  mainGoals: string[];
  competitors: string[];
  monthlyBudget: string;
}

export interface IntegrationStepData {
  googleSearchConsole?: boolean;
  googleAnalytics?: boolean;
  googleAds?: boolean;
  metaAds?: boolean;
}

export const onboardingApi = {
  getStatus: async (): Promise<ApiResponse<OnboardingStatus>> => {
    const { data } = await apiClient.get<ApiResponse<OnboardingStatus>>('/onboarding/status');
    return data;
  },

  saveProfile: async (payload: ProfileStepData): Promise<ApiResponse<void>> => {
    const { data } = await apiClient.post<ApiResponse<void>>('/onboarding/profile', payload);
    return data;
  },

  saveStrategy: async (payload: StrategyStepData): Promise<ApiResponse<void>> => {
    const { data } = await apiClient.post<ApiResponse<void>>('/onboarding/strategy', payload);
    return data;
  },

  saveIntegrations: async (payload: IntegrationStepData): Promise<ApiResponse<void>> => {
    const { data } = await apiClient.post<ApiResponse<void>>('/onboarding/integrations', payload);
    return data;
  },

  complete: async (): Promise<ApiResponse<void>> => {
    const { data } = await apiClient.post<ApiResponse<void>>('/onboarding/complete');
    return data;
  },
};
